/**
 * Checks if the path ends in route, with or without a trailing slash
 */
export function pathEndsWith(path, route) {
    // Matches any number of characters followed by the route string and an optional slash
    var regex = new RegExp(".*".concat(route, "/?$"));
    return regex.test(path);
}
